import React from 'react';
import { Link } from 'react-router-dom';

const Portfolio = () => {
    return (
        <>
        <div  id='portfolio'>
           
                        <div className="my-4 py-4 lg:my-20" id="portfolio">
  <h2 className="my-2 text-center text-3xl text-[#b54a73] uppercase font-bold">Portfolio</h2>
</div>

<div className="px-4 sm:px-6 lg:px-8 lg:my-5" data-aos="fade-down" data-aos-delay="600">
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-12">
    {/* Portfolio Item 1 */}
    <div className="bg-[#f5e3ea] transition-transform duration-300 ease-in-out overflow-hidden text-gray-600 hover:scale-105 rounded-lg shadow-lg">
      <div className="p-4">
        <iframe 
          src="https://www.linkedin.com/embed/feed/update/urn:li:ugcPost:7200025271507296256?compact=1" 
          height="300" 
          width="100%" 
          frameBorder="0" 
          allowFullScreen 
          title="Embedded post"
        ></iframe>
        <p className="font-medium my-4 text-lg text-center text-[#b54a73]">My first portfolio</p>
      </div>
    </div>

    {/* Portfolio Item 2 */}
    <div className="bg-[#f5e3ea] transition-transform duration-300 ease-in-out overflow-hidden text-gray-600 hover:scale-105 rounded-lg shadow-lg">
      <div className="p-4">
        <iframe 
          src="https://drive.google.com/file/d/1C_uyH2ecm5lQ23V8-h7aoUaKsuqBouoL/preview" 
          height="300" 
          width="100%" 
          allow="autoplay"
        ></iframe>
        <p className="font-medium my-4 text-lg text-center text-[#b54a73]">
          <a 
            href="https://hilinamulugeta.github.io/HM/" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            second portfolio 👉Link
          </a>
        </p>
      </div>
    </div>

    {/* Portfolio Item 3 */}
    <div className="bg-[#f5e3ea] transition-transform duration-300 ease-in-out overflow-hidden text-gray-600 hover:scale-105 rounded-lg shadow-lg">
      <div className="p-4">
        <iframe 
          src="https://drive.google.com/file/d/11IwwtvVM_U7LwPcv_tBZqDnRM0NTFlVk/preview" 
          height="300" 
          width="100%" 
          allow="autoplay"
        ></iframe>
        <p className="font-medium my-4 text-lg text-center text-[#b54a73]">Client's portfolio</p>
      </div>
    </div>
  </div>
</div>

                        </div>
               
            
        </>
    )
}

export default Portfolio;